import React, { useState } from "react";
import * as API from "../../utils/api.service";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import { uploadImageOnAWS } from "../../utils/aws.service";
import Cookies from "js-cookie";
import {
  convertToBase64,
  TOAST_ERROR,
  SWIT_SUCCESS,
  TEXT_WITH_NOT_START_SPACE_VALIDATION,
  NUMBER_VALIDATION,
} from "../../utils/common.service";
import { IoMdArrowRoundBack } from "react-icons/io";

export default function AddChallenge() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [challengeType, setChallengeType] = useState("daily");
  let userData = JSON.parse(Cookies.get("dataCA"));
  const [startDate, setStartDate] = useState("");
  const [isActive, setIsActive] = useState("false");
  const [font, setFont] = useState(localStorage.getItem("selectedFont") ?? "Ruqa");

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
    clearErrors,
  } = useForm();

  const [letterImageState, setLetterImageState] = useState(null);
  //const [backgroundImageState, setBackgroundImageState] = useState(null);

  const handleImageChange = async (image, setImageState, fieldName) => {
    const imageSize = image.size / 1024;
    if (imageSize > 3072) {
      TOAST_ERROR("Please select an image smaller than 3MB");
      return;
    }

    try {
      setValue(fieldName, image);
      const bufferImage = await convertToBase64(image);
      setImageState(bufferImage);
      clearErrors(fieldName);
    } catch (error) {
      TOAST_ERROR("An error occurred while processing the image");
    }
  };

  const onSubmit = async (submitData) => {
    try {
      dispatch(setLoader(true));

      let {
        latter_image,
        // background_image,
        challenge_title,
        image_title,
        ar_challenge_title,
        ar_image_title,
        points,
        skip_point,
        total_used_line,
        description,
        ar_description,
        start_date,
        end_date,
        challenge_type,
        font,
      } = submitData;

      // Initialize variables to hold URLs of uploaded images
      let uploadedLetterImage = latter_image;
      // let uploadedBackgroundImage = background_image;

      // Upload original images
      if (latter_image instanceof Blob) {
        try {
          uploadedLetterImage = await uploadImageOnAWS(
            latter_image,
            "challenge"
          );
        } catch (error) {
          TOAST_ERROR("Error uploading letter image");
        }
      }

      // if (background_image instanceof Blob) {
      //   try {
      //     uploadedBackgroundImage = await uploadImageOnAWS(
      //       background_image,
      //       "challenge"
      //     );
      //   } catch (error) {
      //     TOAST_ERROR("Error uploading background image");
      //   }
      // }

      // Construct the request body
      const requestBody = {
        latter_image: uploadedLetterImage,
        //background_image: uploadedBackgroundImage,
        challenge_title,
        image_title,
        ar_challenge_title,
        ar_image_title,
        points,
        skip_point,
        total_used_line,
        description,
        ar_description,
        created_id: userData?.id,
        created_by: userData?.role,
        start_date,
        end_date,
        challenge_type,
        is_free: isActive,
        font,
      };

      // Make the API call
      const { code, message } = await API.insertChallengeApi(requestBody);

      if (code === "1") {
        SWIT_SUCCESS(message);
        navigate(`/manage_challenge`);
        reset();
      }

      dispatch(setLoader(false));
    } catch (err) {
      TOAST_ERROR(err.message);
      dispatch(setLoader(false));
    }
  };

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar
            title="Add Challenge"
            header="Challenge"
            subHeader="Add Challenge"
          />
          <div className="card rounded-3">
            <div className="card-body">
              <div className="d-flex justify-content-lg-start">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => navigate(-1)}
                >
                  <IoMdArrowRoundBack fontSize={"20px"}/>
                </button>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row mb-3 d-flex justify-content-center">
                  {/* Letter Image */}
                  <Controller
                    name="latter_image"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Please choose a letter image" }}
                    render={({ field }) => (
                      <div className="col-md-4 text-center">
                        {letterImageState && (
                          <img
                            src={letterImageState}
                            alt="letter image"
                            className="img-fluid img-thumbnail"
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "10%",
                            }}
                          />
                        )}
                        <input
                          type="file"
                          style={{ display: "none" }}
                          id="latter_image"
                          accept="image/svg+xml"
                          onChange={(e) =>
                            handleImageChange(
                              e.target.files[0],
                              setLetterImageState,
                              "latter_image"
                            )
                          }
                        />
                        <label
                          htmlFor="latter_image"
                          className="btn btn-outline-info m-1"
                        >
                          Choose Letter Image
                        </label>
                        <div className="errorc">
                          {errors.latter_image?.message}
                        </div>
                      </div>
                    )}
                  />
                </div>

                {/* Title Input */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="challenge_title" className="form-label">
                      Challenge Title
                    </label>
                    <input
                      type="text"
                      id="challenge_title"
                      className="form-control"
                      placeholder="Enter Title"
                      {...register(
                        "challenge_title",
                        TEXT_WITH_NOT_START_SPACE_VALIDATION("challenge_title")
                      )}
                      aria-invalid={errors.email ? "true" : "false"}
                    />
                    <div className="errorc">
                      {errors.challenge_title?.message}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="image_title" className="form-label">
                      Image Title
                    </label>
                    <input
                      type="text"
                      id="image_title"
                      className="form-control"
                      placeholder="Enter Title"
                      {...register(
                        "image_title",
                        TEXT_WITH_NOT_START_SPACE_VALIDATION("image_title")
                      )}
                      aria-invalid={errors.email ? "true" : "false"}
                    />
                    <div className="errorc">{errors.image_title?.message}</div>
                  </div>
                </div>

                {/*arebic  Title Input */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="ar_challenge_title" className="form-label">
                      Challenge Title(Arabic)
                    </label>
                    <input
                      type="text"
                      id="ar_challenge_title"
                      className="form-control"
                      placeholder="Enter Title"
                      {...register(
                        "ar_challenge_title",
                        TEXT_WITH_NOT_START_SPACE_VALIDATION("ar_challenge_title")
                      )}
                      aria-invalid={errors.ar_challenge_title ? "true" : "false"}
                    />
                    <div className="errorc">
                      {errors.ar_challenge_title?.message}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="ar_image_title" className="form-label">
                      Image Title(Arabic)
                    </label>
                    <input
                      type="text"
                      id="ar_image_title"
                      className="form-control"
                      placeholder="Enter Title"
                      {...register(
                        "ar_image_title",
                        TEXT_WITH_NOT_START_SPACE_VALIDATION("ar_image_title")
                      )}
                      aria-invalid={errors.email ? "true" : "false"}
                    />
                    <div className="errorc">{errors.ar_image_title?.message}</div>
                  </div>
                </div>

                {/* Points and Skip Point Fields */}
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label htmlFor="points" className="form-label">
                      Points
                    </label>
                    <input
                      type="text"
                      id="points"
                      className="form-control"
                      placeholder="Enter Points"
                      {...register("points", NUMBER_VALIDATION("points"))}
                      aria-invalid={errors.email ? "true" : "false"}
                    />
                    <div className="errorc">{errors.points?.message}</div>
                  </div>

                  <div className="col-md-4">
                    <label htmlFor="skip_point" className="form-label">
                      Skip Points
                    </label>
                    <input
                      type="text"
                      id="skip_point"
                      className="form-control"
                      placeholder="Enter Skip Points"
                      {...register(
                        "skip_point",
                        NUMBER_VALIDATION("skip points")
                      )}
                      aria-invalid={errors.email ? "true" : "false"}
                    />
                    <div className="errorc">{errors.skip_point?.message}</div>
                  </div>

                  <div className="col-md-4">
                    <label htmlFor="total_used_line" className="form-label">
                      Total Line
                    </label>
                    <input
                      type="text"
                      id="total_used_line"
                      className="form-control"
                      placeholder="Enter line"
                      {...register(
                        "total_used_line",
                        NUMBER_VALIDATION("total line")
                      )}
                      aria-invalid={errors.email ? "true" : "false"}
                    />
                    <div className="errorc">
                      {errors.total_used_line?.message}
                    </div>
                  </div>
                </div>

                {/* Challenge Type Dropdown */}
                <div className="row mb-1">
                  <div className="col-md-4">
                    <label htmlFor="challenge_type" className="form-label">
                      Challenge Type
                    </label>
                    <select
                      id="challenge_type"
                      className="form-select"
                      {...register("challenge_type", {
                        required: "Challenge type is required",
                      })}
                      value={challengeType}
                      onChange={(e) => setChallengeType(e.target.value)}
                    >
                      <option value="daily">Daily</option>
                      <option value="monthly">Monthly</option>
                    </select>
                    <div className="errorc">
                      {errors.challenge_type?.message}
                    </div>
                  </div>

                  {/* Challenge start  Date */}
                  <div className="col-md-4 mb-3">
                    <label htmlFor="start_date" className="form-label fw-bold">
                      Start Date & Time
                    </label>
                    <input
                      type="datetime-local"
                      id="start_date"
                      className={`form-control ${
                        errors.start_date ? "errorc" : ""
                      }`}
                      placeholder="Select start date and time"
                      min={new Date().toISOString().slice(0, 16)} // Set min to current date and time
                      {...register("start_date", {
                        required: "Start date and time is required",
                        onChange: (e) => setStartDate(e.target.value), // Update startDate state
                      })}
                    />
                    {errors.start_date && (
                      <div className="errorc">{errors.start_date.message}</div>
                    )}
                  </div>

                  {/* End Date Field */}
                  <div className="col-md-4 mb-3">
                    <label htmlFor="end_date" className="form-label fw-bold">
                      End Date & Time
                    </label>
                    <input
                      type="datetime-local"
                      id="end_date"
                      className={`form-control ${
                        errors.end_date ? "errorc" : ""
                      }`}
                      placeholder="Select end date and time"
                      min={startDate} // Set min to the selected start date and time
                      {...register("end_date", {
                        required: "End date and time is required",
                        validate: (value) =>
                          value > startDate ||
                          "End date and time must be greater than start date and time",
                      })}
                    />
                    {errors.end_date && (
                      <div className="errorc">{errors.end_date.message}</div>
                    )}
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-4">
                    <label htmlFor="font" className="form-label">
                      Font
                    </label>
                    <select
                      id="font"
                      className="form-select"
                      aria-invalid={errors.font ? "true" : "false"}
                      {...register("font", {
                        required: "font is required",
                      })}
                      value={font}
                      onChange={(e) => {
                        setFont(e.target.value);
                        setValue("font", e.target.value); 
                      }}
                    >
                      <option key="Ruqa" value="Ruqa">Ruqa</option>
                      <option key="Naskh" value="Naskh">Naskh</option>
                    </select>
                    <div className="errorc">{errors.font?.message}</div>
                  </div>
                </div>
                
                {/* Description Field */}
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="description" className="form-label">
                      Description
                    </label>
                    <textarea
                      className="form-control"
                      id="description"
                      rows="3"
                      {...register("description")}
                    ></textarea>
                    <div className="errorc">{errors.description?.message}</div>
                  </div>
                </div>

                {/* Description Field */}
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="ar_description" className="form-label">
                      Description(Arabic)
                    </label>
                    <textarea
                      className="form-control"
                      id="ar_description"
                      rows="3"
                      {...register("ar_description")}
                    ></textarea>
                    <div className="errorc">{errors.ar_description?.message}</div>
                  </div>
                </div>

                <div className="form-check form-switch mb-3">
                  <label className="form-check-label" htmlFor="is_active">
                    Is This Free
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="is_active"
                    checked={isActive === "true"}
                    onChange={() =>
                      setIsActive(isActive === "true" ? "false" : "true")
                    }
                  />
                </div>

                {/* Submit Button */}
                <div className="row">
                  <div className="col-md-12 text-center">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
